function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.506.92l13.527 9.236-3.345 4.946L1.16 5.792 4.506.92z",
  fill: "url(#SUSHI_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.033 10.156c-1.164 1.673-5.091 1.018-8.8-1.6C5.45 6.011 3.414 2.592 4.505.92c1.164-1.672 5.091-1.018 8.8 1.6 3.782 2.473 5.819 5.964 4.728 7.637z",
  fill: "url(#SUSHI_svg__paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.687 15.03c-1.163 1.672-5.09 1.017-8.8-1.6-3.71-2.62-5.818-5.965-4.655-7.71 1.164-1.673 5.091-1.019 8.8 1.6 3.71 2.618 5.746 6.036 4.655 7.71z",
  fill: "url(#SUSHI_svg__paint2_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.033 10.156l-3.346 4.946c-1.163 1.673-5.09.945-8.8-1.6a21.933 21.933 0 01-2.036-1.6c.509-.073 1.163-.364 1.818-1.091 1.164-1.237 1.745-1.528 2.254-1.455.51 0 1.091.51 2.037 1.746.945 1.236 2.255 1.6 3.055.945.072-.073.145-.073.218-.145.654-.51.873-.728 2.109-3.055.29-.582 1.31-1.527 2.691-1.09.364.945.364 1.745 0 2.4z",
  fill: "#0E0F23"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.524 9.865c-1.018 1.455-4.582.727-8-1.673-3.492-2.4-5.528-5.454-4.51-6.909 1.018-1.455 4.582-.727 8 1.673 3.419 2.4 5.455 5.455 4.51 6.91z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.324 7.683c-.51.728-2.255.364-4-.8C8.65 5.72 7.633 4.193 8.142 3.465c.509-.727 2.254-.364 4 .8 1.673 1.164 2.69 2.691 2.182 3.418z",
  fill: "#CF65AE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.214 2.592c0-.073-.072-.145-.145-.073-.073.073-.146.073-.146.146.073.218.146.364.146.509 0 .073.073.145.145.073.073 0 .146-.073.073-.146 0-.145 0-.29-.073-.509zM4.578 3.756c0-.073-.073-.146-.146-.073-.072.073-.072.073-.072.145.8 1.819 2.472 3.782 4.654 5.237.073.073.146 0 .219 0 .072-.073 0-.145 0-.218C6.978 7.392 5.378 5.5 4.578 3.756zM13.378 10.883c-.072 0-.145 0-.145.073s0 .146.073.146c.218.072.509.145.727.218.073 0 .145 0 .145-.073s0-.146-.072-.146c-.219-.072-.51-.145-.728-.218zM14.688 11.174a.156.156 0 00-.146.146c0 .072.073.145.146.145.581.073 1.236.146 1.745.073a.156.156 0 00.145-.146.156.156 0 00-.145-.145c-.582.073-1.164 0-1.745-.073z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SUSHI_svg__paint0_linear",
  x1: 7.159,
  y1: -0.395,
  x2: 9.842,
  y2: 8.817,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03B8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA52A0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SUSHI_svg__paint1_linear",
  x1: 9.357,
  y1: -1.035,
  x2: 12.04,
  y2: 8.177,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03B8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA52A0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SUSHI_svg__paint2_linear",
  x1: 4.987,
  y1: 0.238,
  x2: 7.67,
  y2: 9.45,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03B8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA52A0"
})));

function SvgSushi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default __webpack_public_path__ + "e0b69eebb0041f57bb95746587b934db.svg";
export { SvgSushi as ReactComponent };